import { Sex } from "./sex";

export class Person {
    id: number = 0;
    name: string = '';
    surname: string = '';
    birthdate: Date = new Date();
    sex?: Sex;
}
